import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper, Btn } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import { PaginationLimit } from "../../Config";
import { IoCopySharp, IoEye } from "react-icons/io5";
import moment from "moment";
import { capitalizeFirstLetter, handleCopy, truncateText } from "../../helpers";
import { FiChevronRight } from "react-icons/fi";
import { IoMdMore } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { BsBank2 } from "react-icons/bs";

const Table = ({
    apiData,
    setSelectedData,
    //setShowEditLandlord,
    setShowViewProps,
    setShowViewLeaseModel,
    //setIsAddDuesModal
}) => {
    const storageKey = `landlord_list_page`;
    const navigate = useNavigate();
    const [data, setData] = useState([
        {
            deviceName: "",
            extractionTime: "",
            processingTime: "",
            drops: "",
            action: "",
        },
    ]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
    const [previousId, setPreviousId] = useState(null);
    //const [currentPage, setCurrentPage] = useState(0);
    const [openActionMenu, setOpenActionMenu] = useState(null);

    // Load saved page index
    const storageValue = sessionStorage.getItem(storageKey);
    const savedPage = storageValue !== null ? Number(storageValue) : 0;
    const [currentPage, setCurrentPage] = useState(savedPage);
    useEffect(() => {
        setCurrentPage(savedPage);
    }, [savedPage]);

    const toggleRow = (index) => {
        setSelectedRow(selectedRow === index ? null : index);
    };

    const goToSummary = (item) => {
        navigate(`/landlord/details`, {
            state: {
                landlordId: item.id,
            },
        });
    };

    const ActionBtns = (item) => {
        const openMenu = (id) => {
            setPreviousId(openActionMenu);
            setOpenActionMenu((prevId) => {
                return prevId === id ? null : id;
            });
        };

        return (
            <ActionBtnWrapper>
                {openActionMenu === item.id && (
                    <MenuOptions id="menuOptions">
                        {/* <MenuItem
                            title="Edit Details"
                            onClick={() => edit(item)}
                        >
                            <IoEye className="text-gray-700 " /> Edit Details
                        </MenuItem>
                        <MenuItem
                            title="KYC Details"
                            onClick={() => kycDetail(item)}
                        >
                            <MdVerifiedUser className="text-gray-700 " /> KYC Details
                        </MenuItem>
                        <MenuItem
                            title="Add Due"
                            onClick={() => addDues(item)}
                        >
                            <TbCalendarDue className="text-gray-700 " /> Add Due
                        </MenuItem> */}
                        <MenuItem
                            title="View Details"
                            onClick={() => {
                                setOpenActionMenu(null);
                                goToSummary(item);
                            }}
                        >
                            <IoEye className="text-gray-700 " /> View Details
                        </MenuItem>
                        <MenuItem
                            title="Bank Details"
                            onClick={() => {
                                navigate('/landlord/bank-details', { state: { leaseDetails: item } });
                                setOpenActionMenu(null);
                            }}
                        >
                            <BsBank2 className="text-gray-700 " /> Bank Details
                        </MenuItem>
                        {/* <MenuItem
                            title="Transaction Details"
                            onClick={() => {
                                navigate('/landlord/transactions', { state: { leaseDetails: item } });
                                setOpenActionMenu(null);
                            }}
                        >
                            <GrTransaction className="text-gray-700 " /> Transaction Details
                        </MenuItem> */}
                    </MenuOptions>
                )
                }
                <Btn title="Actions" type="button" onClick={() => openMenu(item.id)}>
                    <IoMdMore className="text-gray-600" size={24} />
                </Btn>
            </ActionBtnWrapper >
        );
    };

    // const edit = (item) => {
    //     setSelectedData(item);
    //     setShowEditLandlord(true);
    // };
    // const addDues = (item) => {
    //     setSelectedData(item);
    //     setIsAddDuesModal(true);
    // };
    const kycDetail = (item) => {
        setSelectedData(item);
        setShowViewLeaseModel(true);
    };

    const showProps = (item) => {
        setSelectedData(item);
        setShowViewProps(true);
    };

    const getProperties = (item) => {
        return (
            <div className="flex items-center gap-2">
                <button
                    onClick={() => showProps(item)}
                    className="
                        px-3 py-1.5
                        bg-neutral-100 hover:bg-neutral-200
                        text-sm font-medium
                        text-gray-700
                        flex items-center gap-2
                        rounded-full
                        transition
                    "
                >
                    {item.propertiesCount}
                    <FiChevronRight size={14} />
                </button>

            </div>
        );
    };

    useEffect(() => {
        if (apiData) {
            const tempData = apiData.map((item) => ({
                name: getName(item),
                agreementDuration: agreementDuration(item),
                dues: getDuesAmount(item),
                // rent: (
                //     <div className="flex items-center gap-2">
                //         <button onClick={() => unpaidExpenses(item)} title="Unpaid Rent" className=" hover:text-primary-color flex items-center gap-2"><span className="text-gray-700">₹{item.rent}</span><FiChevronRight size={14} /></button>
                //     </div>
                // ),
                properties: getProperties(item),
                rent: <Payment>₹{item?.lifetimePayment || 0}</Payment>,
                createdAt: moment(item.createdAt).format('DD, MMM YY'),
                action: ActionBtns(item),
            }));
            setData(tempData);
        }
    }, [apiData, openActionMenu]);

    const getDuesAmount = (item) => {
        const total = (item.properties || []).reduce(
            (sum, d) => sum + Number(d.pendingDues || 0),
            0
        );

        if (!total) {
            return (
                <span className="text-xs text-green-600 bg-green-50 px-3 py-1 rounded-full">
                    No dues
                </span>
            );
        }

        return <Amount onClick={() => goToSummary(item)}>₹{total}</Amount>;
    };


    const getDuesAmountOld = (item) => {
        const totalPendingDues = (item.properties || []).reduce(
            (sum, data) => sum + Number(data.pendingDues || 0),
            0
        );
        return <Amount onClick={() => goToSummary(item)}>{"₹" + (totalPendingDues || 0)}</Amount>;
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                !event.target.closest("#menuOptions") &&
                !event.target.closest(".action-btn")
            ) {
                setOpenActionMenu(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const agreementDuration = (item) => {
        return (
            <div className="flex gap-3 ">
                <div className="flex flex-col text-sm text-gray-600">
                    <span>
                        {item.startDate
                            ? moment(item.startDate).format("DD-MMM-YY")
                            : "-"}
                        {' - '}
                        {item.endDate
                            ? moment(item.endDate).format("DD-MMM-YY")
                            : "-"}
                    </span>
                </div>
            </div>
        );
    };

    const getName = (item) => {
        const name = capitalizeFirstLetter(item?.name || "N/A");

        return (
            <UserImageWrapper onClick={() => goToSummary(item)}>
                <UserImage src={Images.Avatar} alt={name} />

                <div className="flex flex-col min-w-0">
                    <span className="text-sm font-medium text-gray-900 truncate max-w-[180px]">
                        {name}
                    </span>

                    <div className="flex items-center gap-1 text-xs text-gray-400">
                        <span>#{item.mobile}</span>
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                handleCopy(item.mobile);
                            }}
                            className="hover:text-gray-600 transition"
                            title="Copy number"
                        >
                            <IoCopySharp size={12} />
                        </button>
                    </div>
                </div>
            </UserImageWrapper>
        );
    };


    const getNameOld = (item) => {
        const name = capitalizeFirstLetter(item?.name || 'N/A');
        return (
            <UserImageWrapper onClick={() => goToSummary(item)}>
                <UserImage src={Images.Avatar} alt={`Avatar for ${item.landlordName}`} />
                <div className="flex flex-col gap-1">
                    <span className="text-gray-600 text-sm block max-w-[160px] break-words line-clamp-2">
                        {truncateText(name, 35)}{" "}
                    </span>
                    <div className="flex gap-1">
                        <span className="text-gray-400 text-xs">#{item.mobile}</span>
                        <button onClick={(e) => {
                            e.stopPropagation();
                            handleCopy(item.mobile);
                        }}>
                            <IoCopySharp size={10} className="text-gray-400" />
                        </button>
                    </div>
                </div>
            </UserImageWrapper>
        );
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const columns = React.useMemo(() => {
        if (isMobileView) {
            return [
                {
                    Header: "Name",
                    accessor: "name",
                },
                {
                    Header: "Properties",
                    accessor: "properties",
                },
            ];
        }
        return [
            {
                Header: "Landlord",
                accessor: "name",
            },
            {
                Header: "Dues",
                accessor: "dues",
            },
            {
                Header: "Payment",
                accessor: "rent",
            },
            {
                Header: "Lease",
                accessor: "properties",
            },
            // {
            //     Header: "Created At",
            //     accessor: "createdAt",
            // },
            {
                Header: "Action",
                accessor: "action",
            },
        ];
    }, [isMobileView]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex },
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
    } = useTable(
        {
            data,
            columns,
            initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
        },
        useSortBy,
        usePagination
    );

    useEffect(() => {
        //setCurrentPage(pageIndex);
        sessionStorage.setItem(storageKey, pageIndex);
    }, [pageIndex, storageKey]);

    return (
        <>
            <CustomTable {...getTableProps()}>
                <Thead>
                    {headerGroups.map((headerGroup) => (
                        <Tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                    {column.render("Header")}
                                    <span>
                                        {column.isSorted ? (
                                            <img
                                                src={Images.Arrow}
                                                alt="down arrow"
                                                className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                                                    } w-1.5 inline-block ml-1.5`}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
                    {page.map((row, rowIndex) => {
                        prepareRow(row);
                        const rowData = apiData[rowIndex];
                        return (
                            <React.Fragment key={rowIndex}>
                                <Tr
                                    {...row.getRowProps({ style: { height: "80px" } })}
                                    hasdata={(apiData?.length > 0).toString()}
                                >
                                    {row.cells.map((cell, cellIndex) => {
                                        return (
                                            <Td
                                                {...cell.getCellProps()}
                                                onClick={() => {
                                                    if (
                                                        cellIndex === 0 ||
                                                        (cellIndex === 1 && window.innerWidth < 768)
                                                    ) {
                                                        toggleRow(rowIndex);
                                                    }
                                                }}
                                            >
                                                {cell.render("Cell")}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                                {selectedRow === rowIndex && window.innerWidth < 768 && (
                                    <Tr>
                                        <Td colSpan={columns.length}>
                                            <ul className="flex flex-col gap-2">
                                                <li>
                                                    <strong>Rent</strong>{" "}
                                                    {data[rowIndex].rent}
                                                </li>
                                                <li>
                                                    <strong>Rent Date</strong>{" "}
                                                    {data[rowIndex].rentDate}
                                                </li>
                                                <li>
                                                    <strong>Agreement Duration</strong>{" "}
                                                    {data[rowIndex].agreementDuration}
                                                </li>
                                                <li>
                                                    <strong>Action</strong>{" "}
                                                    {data[rowIndex].action}
                                                </li>
                                            </ul>
                                        </Td>
                                    </Tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Tbody>
            </CustomTable>
            {apiData?.length > 0 && (
                <PaginationWrapper>
                    <div className="px-2">
                        Page{" "}
                        <em>
                            {pageIndex + 1} of {pageOptions.length}
                        </em>
                    </div>

                    <div className="flex gap-1">
                        <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
                            <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
                        </PrevBtn>
                        <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
                            <img
                                src={Images.Arrow}
                                alt="arrow"
                                className="w-2 rotate-180 opacity-75"
                            />
                        </NextBtn>
                    </div>
                </PaginationWrapper>
            )}
        </>
    );
};

const CustomTable = tw.table` w-full text-gray-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
    props.hasdata === "true"
        ? "border-b"
        : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const UserImageWrapper = tw.div` flex items-center gap-2 cursor-pointer`;
const UserImage = tw.img`w-10 h-10 rounded-full `;
const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;

// const MenuItem = tw.div`flex items-center gap-2 px-4 py-2 text-base font-normal cursor-pointer hover:bg-gray-100`;
// const MenuOptions = tw.div`absolute bottom-10 right-0 py-4 w-max bg-white z-10 rounded-lg shadow-lg border border-gray-200 flex flex-col`;


const MenuItem = tw.div`
  flex items-center gap-2 
  px-4 py-2 
  text-sm 
  cursor-pointer 
  hover:bg-gray-50
`;
const MenuOptions = tw.div`
  absolute bottom-10 right-0
  py-2 w-44
  bg-white z-20
  rounded-xl
  shadow-xl
  border border-gray-200
  flex flex-col
`;

//const Amount = tw.p`text-gray-600 text-sm bg-rose-100 px-3 py-1 rounded-md inline-flex cursor-pointer`;
const Amount = tw.p`
  text-rose-700
  bg-rose-50
  text-sm
  font-semibold
  px-3 py-1
  rounded-full
  inline-flex
  cursor-pointer
`;

const Payment = tw.span`
  bg-neutral-100
  text-gray-800
  px-3 py-1
  rounded-full
  text-sm
  font-medium
  inline-flex
`;

export default Table;